module.exports = __webpack_public_path__ + "img/shelf-placeholder.437411aa.svg";